import { useEffect, useState } from "react";

import { getFeatureFlagKey, getFeatureFlagUrl } from "src/env";

interface FlagValueResponse {
  key: string;
  state: string;
  value: FFValue;
}

type FFValue = { boolean: string } | { string: string } | { json: unknown };

// Fails closed: false while loading, when unconfigured, and on any error.
export function useFeatureFlag(key: string): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const url = getFeatureFlagUrl();
    const ffKey = getFeatureFlagKey();
    if (!url || !ffKey) return;

    let cancelled = false;
    fetch(`${url}/v1/flags/${encodeURIComponent(key)}/value`, {
      headers: { Authorization: `Key ${ffKey}` },
    })
      .then<FlagValueResponse>((res) => {
        if (!res.ok) return Promise.reject(new Error(`FF ${key}: ${res.status}`));
        return res.json();
      })
      .then((data) => {
        if (!cancelled) setEnabled("boolean" in data.value && data.value.boolean === "true");
      })
      .catch(() => {
        // stay disabled on any error (network failure, non-ok response, bad body)
      });

    return () => {
      cancelled = true;
    };
  }, [key]);

  return enabled;
}
